<template>
  <div class="listmain ">
      <h1 class="firTitle">设备管理</h1>
    <p>头文件 OrionSDK+Account.h ，需要传入当前 app 的登录信息手机号。</p>
      <h3 class="sedTitle">OrionSDKDataSource</h3>
      <span>
<span>
<p class="ql-long-7802039">
	<span class="ql-author-7802039 ql-size-9">无论只用API还是UI，都需要用户去管理自己的设备。头文件 OrionSDK+Device.h</span>
</p>

<p class="ql-long-7802039">
	<strong class="ql-author-7802039 ql-size-9">获取音箱授权码（重要）</strong>
</p>

<p class="ql-long-7802039">
	<span class="ql-author-7802039 ql-size-9">授权码生命周期：</span>
</p>

<p class="ql-long-7802039">
	<span class="ql-author-7802039 ql-size-9">1.通过手机APP SDK获得一个授权码</span>
</p>

<p class="ql-long-7802039">
	<span class="ql-author-7802039 ql-size-9">2.将授权码传递到音箱</span>
</p>

<p class="ql-long-7802039">
	<span class="ql-author-7802039 ql-size-9">3.音箱用此授权码请求猎户服务端，获得音箱访问猎户服务端的Token</span>
</p>
</span>
</span>
          <highlight-code lang="javascript">
             <span>
                 // 获取音箱授权码，用于和音箱交互
[[OrionSDK shared] requestDeviceTokenWithCompletion:^(NSDictionary * _Nullable tokenInfo, NSError * _Nullable error) {
    NSLog(@"获取音箱授权码 %@",tokenInfo);
}];
             </span>
    </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">获取当前用户设备列表</span>
      </p>
      <highlight-code lang="javascript">
         <span>
             /**
 * @brief 请求设备列表
 */
- (void)requestDataSource:(nullable void(^)(NSArray * __nullable devices,NSArray * __nullable apiSource, NSError * __nullable error))completion {
    [[OrionSDK shared] requestDeviceListWithCompletion:^(NSDictionary * _Nullable devicesInfo, NSError * _Nullable error) {
        if (error) {
            completion(nil,nil,error);
            return ;
        }
        NSArray *deviceList = [devicesInfo objectForKey:@"data"];
        NSArray * apiSource = [self createDataSource];
        if (devicesInfo) {
            NSMutableArray *userDevices= [NSMutableArray array];
            if ([deviceList count] > 0) {
                for (NSDictionary *info in deviceList) {
                    OVSDeviceModel *device = [[OVSDeviceModel alloc] init];
                    device.controlSpeakerId = [[info objectForKey:@"speakerId"] stringValue];
                    device.controlSpeakerDeviceId = [info objectForKey:@"speakerDeviceId"];
                    device.imei = [info objectForKey:@"imei"];
                    device.model = [info objectForKey:@"model"];
                    device.name = [info objectForKey:@"name"];
                    device.osVersion = [info objectForKey:@"osVersion"];
                    device.sn = [info objectForKey:@"sn"];
                    device.ssid = [info objectForKey:@"ssid"];
                    device.version = [info objectForKey:@"version"];
                    device.speakerAndroidId = [info objectForKey:@"speakerAndroidId"];
                    [userDevices addObject:device];
                }
                if (![OVSUserModel sharedInstance].currentDivece) {
                    // 设置当前设备用于信息流数据，可切换当前设备
                    OVSDeviceModel *device = [userDevices lastObject];
                    [OVSUserModel sharedInstance].currentDivece = device;
                }
                [OVSUserModel sharedInstance].deviceArray = userDevices;
            }
            completion(deviceList,apiSource,nil);
        }
    }];
}
         </span>

      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">更新设备信息</span>
      </p>
      <highlight-code lang="javascript">
         <span>
          /**
 * @brief 音箱更新 如修改音箱名称
 */
- (void)updateDeviceInfo {
    NSDictionary *deviceInfo = @{
      @"speaker_id" : self.deviceInfo.controlSpeakerId,
      @"speaker_device_id" : self.deviceInfo.controlSpeakerDeviceId,
      @"name" : @"小豹",
      @"version" : self.deviceInfo.version,
      @"model" : self.deviceInfo.model,
      @"sn" : self.deviceInfo.sn,
      @"ssid" : self.deviceInfo.ssid,
      @"imei" : self.deviceInfo.imei?:@"",
      @"os_version" : self.deviceInfo.osVersion?:@""
      };
    [[OrionSDK shared] requestUpdateDevice:deviceInfo completion:^(NSDictionary * _Nullable responseInfo, NSError * _Nullable error) {
        NSLog(@"updateDeviceInfo   =%@",responseInfo);
        [super addContent:[@"音箱更新 " stringByAppendingString:(responseInfo?responseInfo.description:@"")]];
    }];
}
         </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">切换设备</span>
      </p>
      <highlight-code lang="javascript">
          <span>
              /**
 * @brief 切换设备
 */
- (void)switchDevice {
    // 用户解绑后需要，需要指定一台主设备。也就是切换设备。
    NSDictionary *updateUserdeviceInfo = @{ @"control_speaker_id" : self.deviceInfo.controlSpeakerId,
                                      @"control_speaker_device_id":  self.deviceInfo.controlSpeakerDeviceId};
    NSDictionary *mobileDeviceInfo = @{ @"mobile_id" : ([OVSUserModel mobileId]?:@""),
                                 @"mobile_device_id" : ([OVSUserModel mobileDeviceId]?:@"")};
    [[OrionSDK shared] controlUpdateDevice:updateUserdeviceInfo
                                mobileInfo:mobileDeviceInfo
                                completion:^(NSDictionary * _Nullable responseInfo, NSError * _Nullable error) {
                                    [super addContent:[@"切换设备 " stringByAppendingString:(responseInfo?responseInfo.description:@"")]];
                                }];
}
          </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">获取设备状态</span>
      </p>
      <highlight-code lang="javascript">
         <span>
             /**
 * @brief 音箱状态获取
 */
- (void)getDeviceState {
    NSDictionary *deviceStateInfo = @{ @"control_speaker_id" : self.deviceInfo.controlSpeakerId};
    [[OrionSDK shared] requestDeviceStatus:deviceStateInfo completion:^(NSDictionary * _Nullable statusInfo, NSError * _Nullable error) {
        [super addContent:[@"音箱状态获取 " stringByAppendingString:(statusInfo?statusInfo.description:@"")]];
    }];
}

         </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">获取设备的信息</span>
      </p>
      <highlight-code lang="javascript">
         <span>
             /**
 * @brief 获取设备的信息
 */
- (void)getDeviceInfo {
    NSDictionary *getdeviceInfo = @{ @"control_speaker_id" : self.deviceInfo.controlSpeakerId,
                              @"control_speaker_device_id" : self.deviceInfo.controlSpeakerDeviceId};
    [[OrionSDK shared] requestDeviceInfo:getdeviceInfo completion:^(NSDictionary * _Nullable deviceInfo, NSError * _Nullable error) {
        [super addContent:[@"获取设备的信息 " stringByAppendingString:(deviceInfo?deviceInfo.description:@"")]];
    }];
}
         </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">用户解绑某个设备</span>
      </p>
      <highlight-code lang="javascript">
         <span>
             /**
 * @brief 解绑某个设备
 */
- (void)deleteDevice {
    // 注意：为了功能正常demo中不要解绑，否则会没有数据。
    NSDictionary *deletedeviceInfo = @{ @"control_speaker_id" : self.deviceInfo.controlSpeakerId,
                                 @"control_speaker_device_id" : self.deviceInfo.controlSpeakerDeviceId};
    [[OrionSDK shared] deleteDevice:deletedeviceInfo completion:^(NSDictionary * _Nullable responseInfo, NSError * _Nullable error) {
        [super addContent:[@"用户解绑某个设备 " stringByAppendingString:(responseInfo?responseInfo.description:@"")]];
        [OVSUserModel sharedInstance].currentDivece = nil;
        for (int i =0; i < [OVSUserModel sharedInstance].deviceArray.count; i++) {
            OVSDeviceModel *device = [[OVSUserModel sharedInstance].deviceArray objectAtIndex:i];
            if ([device.controlSpeakerId isEqualToString:self.deviceInfo.controlSpeakerId]) {
                [[OVSUserModel sharedInstance].deviceArray removeObject:device];
            }
        }
        if ([OVSUserModel sharedInstance].deviceArray.count>0) {
            [self.navigationController popViewControllerAnimated:YES];
        } else {
            [self.navigationController popToRootViewControllerAnimated:YES];
        }
    }];
}
         </span>
      </highlight-code>

     <p></p>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/Equipment.vue